import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.planning')
  .service('PlanningTemplatesDefaultDraftAPI', PlanningTemplatesDefaultDraftAPI);

function PlanningTemplatesDefaultDraftAPI(): BringozApi {
  return {
    base: `/planning/templates/default/draft`,
    infiniteScroll: {
      address: `/planning/templates/default/draft`,
      cmd: 'GET'
    },
    actions: {
      getDefaultDraftTemplates: {
        address: '',
        cmd: 'GET',
        updateable: false
      },
      getDefaultDraftTemplate: {
        address: '{id}',
        cmd: 'GET',
        updateable: false
      },
      createDefaultDraftTemplate: {
        address: '',
        cmd: 'PUT',
        updateable: true
      },
      updateDefaultDraftTemplate: {
        address: '{id}',
        cmd: 'POST',
        updateable: true
      },

    }
  }
}
